import { QUESTIONS, PRACTICE } from '../constants/assessmentItemType';

export const getIsIPSDataFetched = (state) => state.isDataFetched;

export const getIPSContent = (state, pageType, questionIndex = 0) => {
    let content;
    switch (pageType) {
    case QUESTIONS:
        content = state.questions;
        break;
    case PRACTICE:
        content = state.practice;
        break;
    default:
        return {};
    }
    return content[questionIndex];
};

export const getIPSPossibleResponses = (state, pageType, questionIndex = 0) => {
    const content = getIPSContent(state, pageType, questionIndex);
    if (content) {
        return content.possibleResponses;
    }
    return [];
};

export const getIPSStimulusAudio = (state, pageType, questionIndex = 0) => {
    const content = getIPSContent(state, pageType, questionIndex);
    if (content) {
        return content.stimulus.audio;
    }
    return '';
};

export const getIPSStimulusImage = (state, pageType, questionIndex = 0) => {
    const content = getIPSContent(state, pageType, questionIndex);
    if (content) {
        return content.stimulus.image;
    }
    return '';
};

export const getIPSQuestionSpecificAudio = (state, pageType, questionIndex = 0) => {
    const content = getIPSContent(state, pageType, questionIndex);
    if (content) {
        return content.stimulus.phoneme;
    }
    return '';
};

export const getIPSTotalQuestions = (state, pageType) => ((pageType === PRACTICE) ? state.practice.length : state.questions.length);

export const getIPSPracticeCorrectResponseId = (state) => {
    const content = getIPSContent(state, PRACTICE);
    if (content) {
        return content.correctResponse;
    }
    return '';
};
